import { render, staticRenderFns } from "./referans.vue?vue&type=template&id=d55f342e&scoped=true"
import script from "./referans.vue?vue&type=script&lang=js"
export * from "./referans.vue?vue&type=script&lang=js"
import style0 from "./referans.vue?vue&type=style&index=0&id=d55f342e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55f342e",
  null
  
)

export default component.exports